export default "__VITE_ASSET__C1u_RDVE__"